// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3LPCE","selects":"Documents_selects__5i7Tq"};